export default __webpack_public_path__ + "static/media/certificate2.ae7afbfa.svg";